<template lang="pug">
    div(
        v-if="hasSocialLinks"
        class="flex justify-center items-center lg:justify-start gap-x-9"
    )
        a(
            v-if="$config.runtime.theme.social.facebook"
            :href="`https://www.facebook.com/${$config.runtime.theme.social.facebook}`"
            target="_blank"
            rel="noopener"
        )
            img(
                src="@/assets/social/facebook.svg"
                alt="facebook"
                class="h-5 w-5"
                loading="lazy"
            )

        a(
            v-if="$config.runtime.theme.social.twitter"
            :href="`https://twitter.com/${$config.runtime.theme.social.twitter}`"
            target="_blank"
            rel="noopener"
        )
            img(
                src="@/assets/social/twitter.svg"
                alt="twitter"
                class="h-5 w-5"
                loading="lazy"
            )

        a(
            v-if="$config.runtime.theme.social.instagram"
            :href="`https://www.instagram.com/${$config.runtime.theme.social.instagram}`"
            target="_blank"
            rel="noopener"
        )
            instagram(aria-label="instagram"  class="h-5 w-5 text-gray-light fill-current")

        a(
            v-if="$config.runtime.theme.social.youtube"
            :href="`https://www.youtube.com/user/${$config.runtime.theme.social.youtube}`"
            target="_blank"
            rel="noopener"
        )
            img(
                src="@/assets/social/youtube-gray.svg"
                alt="youtube"
                class="h-4 w-5"
                loading="lazy"
                )

        a(
            v-if="$config.runtime.theme.social.tiktok"
            :href="`https://www.tiktok.com/${$config.runtime.theme.social.tiktok}`"
            target="_blank"
            rel="noopener"
        )
            img(
                src="@/assets/social/tiktok.svg"
                alt="tiktok"
                class="h-5 w-5"
                loading="lazy"
            )
</template>

<script>
import Instagram from '@/assets/social/instagram/?inline'

export default {
    name: 'SocialMedia',
    components: {
        Instagram,
    },
    computed: {
        hasSocialLinks() {
            return Object.keys(this.$config.runtime.theme.social).length > 0
        },
    },
}
</script>
